<template>
     <panel/>
</template>
<script setup>

import panel from "@/agent/components/panel/panelComponent.vue";
import {$ref} from "vue/macros";
import Loading from "@/customer/App.vue";

let status = $ref('true');
setTimeout(() => {
  status = false;
}, 1500);

</script>